import { createSelector } from '@reduxjs/toolkit';

import { equalsIgnoreCase } from 'src/utils/stringUtils';

import type { DataStateType } from '../data/types';

const getData = (state): DataStateType => state.data;

// citizenships
const _getCitizenships = createSelector(getData, (data) => data.citizenships);

export const getCitizenships = createSelector(
  _getCitizenships,
  (citizenships): { value: number; label: string }[] =>
    citizenships
      ? citizenships.map(([label, value]) => ({ value, label }))
      : [],
);

// validatedTourists
const getValidatedTourists = createSelector(
  getData,
  (data) => data.validatedTourists,
);

export const getIsTouristValidated = createSelector(
  [getValidatedTourists, (_, index) => index],
  (validatedTourists, index) =>
    validatedTourists && validatedTourists.includes(index),
);

export const getIsTouristValidatedCount = createSelector(
  getValidatedTourists,
  (validatedTourists) => validatedTourists.length,
);

export const makeGetIsTouristValidated = () => getIsTouristValidated;

// mockTourists
export const getMockTourists = createSelector(
  getData,
  (data) => data.mockTourists,
);

// tourists
export const getSavedTourists = createSelector(
  getData,
  (data) => data.tourists,
);

export const getSavedTouristsByDocType = createSelector(
  [getSavedTourists, (_, docType) => docType],
  (savedTourists, docType) =>
    savedTourists?.filter((tourist) =>
      equalsIgnoreCase(docType, tourist.docType),
    ),
);

// resetDefaultClientData
const _getIsResetDefaultClientData = createSelector(
  getData,
  (data) => data.resetDefaultClientData,
);

export const getIsResetDefaultClientData = createSelector(
  _getIsResetDefaultClientData,
  (isResetDefaultClientData) => Boolean(isResetDefaultClientData),
);
